/**
 * Aparência do badge de evento na coluna EVENTO.
 *
 * TODOS os eventos usam a MESMA cor, por decisão de produto: a coluna serve
 * para ler o que aconteceu, não para colorir a tabela. Variar a cor por tipo
 * de evento deixava a trilha visualmente ruidosa, ainda mais numa cotação com
 * muitas atividades.
 *
 * Os RÓTULOS continuam vindo do backend (`eventLabel`), que é a fonte única de
 * verdade — aqui é só apresentação.
 */
export type QuoteActivityColorScheme =
  | 'blue'
  | 'green'
  | 'purple'
  | 'yellow'
  | 'sky'
  | 'lightGreen'
  | 'success'
  | 'error'
  | 'warning'
  | 'gray';

/** Cor única de todos os badges da trilha. */
export const QUOTE_ACTIVITY_COLOR: QuoteActivityColorScheme = 'blue';

export function getQuoteActivityColor(_event: string): QuoteActivityColorScheme {
  return QUOTE_ACTIVITY_COLOR;
}
